import { useState } from "react";
import { AlertTriangle, ChevronDown, MessageSquare } from "lucide-react";
import { openFeedback } from "./Feedback";

// "Solicit feedback" card placed top-right on key pages. The copy is the default; admin-editability
// and the universal on/off toggle are owned by Configuration Management (a simple flag for now).
export const SHARE_THOUGHTS_ENABLED = true;

const INTRO =
  "Vibe-coded with Claude Code, Claude Design, and Claude Cowork using Fable 5/Opus 4.8. " +
  "Let me know what you think!";

const DETAIL =
  "Fable 5 was used to ideate, design, and build much of the frontend in under a day. Opus 4.8 was " +
  "used to complete the implementation and build the backend, taking roughly a week. My personal " +
  "estimate would've been 6-8 weeks to hand-build and forever to fine-tune visuals. With Fable 5, I " +
  "expect this would've taken 3-5 days at most. With tighter tooling between Design and Code, perhaps " +
  "even less.";

export function ShareThoughts({ className }: { className?: string }) {
  const [open, setOpen] = useState(false);
  if (!SHARE_THOUGHTS_ENABLED) return null;
  return (
    <aside className={`share-thoughts card card-pad ${className ?? ""}`}>
      <p className="ds-card-kicker mono">Share your thoughts</p>
      <p className="share-thoughts-text">{INTRO}</p>
      <button
        type="button"
        className="share-thoughts-more"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        {open ? "Read less" : "Read more"}
        <ChevronDown className={`share-thoughts-caret ${open ? "is-open" : ""}`} size={13} />
      </button>
      {open && <p className="share-thoughts-detail">{DETAIL}</p>}
      <div className="share-thoughts-actions">
        <button type="button" className="btn btn-sm btn-primary" onClick={() => openFeedback()}>
          <MessageSquare size={14} /> Send feedback
        </button>
        <button type="button" className="btn btn-sm" onClick={() => openFeedback("bug")}>
          <AlertTriangle size={14} /> Report a bug
        </button>
      </div>
    </aside>
  );
}
